import SelectProps from "./types"
import { Arrow, ContentSelect, LabelSelect, OptionSelect, SelectStyled } from "./styles"

import clsx from "clsx"
import { useCallback, useMemo, useState } from "react"
import IconCaretDown from "components/icons/Beat/IconCaretDown"

export const Select = ({
  value = "",
  setValue,
  options,
  className,
  disabled,
  allowEmpty = true,
  ...props
}: SelectProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const onFocus = useCallback(() => {
    setIsOpen(true)
  }, [])

  const onBlur = useCallback(() => {
    setIsOpen(false)
  }, [])

  const isNothingSelected = useMemo(() => {
    return !value
  }, [value])

  return (
    <ContentSelect className={`active-${value.length > 0}`}>
      <SelectStyled
        onFocus={onFocus}
        onBlur={onBlur}
        name="select"
        className={clsx(["input-select", className, isNothingSelected], { hideValue: isNothingSelected })}
        onChange={(e) => setValue(e.target.value)}
        value={value}
        disabled={disabled}
      >
        {allowEmpty && <option value="">Nada selecionado</option>}
        {options.map((option) => {
          return (
            <OptionSelect key={option.value} value={option.value}>
              {option.label}
            </OptionSelect>
          )
        })}
      </SelectStyled>
      <Arrow className={clsx({ isOpen })}>
        <IconCaretDown />
      </Arrow>
      {props.label && <LabelSelect className="select-label">{props.label}</LabelSelect>}
    </ContentSelect>
  )
}
